import { render, staticRenderFns } from "./FavoriteEmailUpdate.vue?vue&type=template&id=4db2400b&scoped=true&"
import script from "./FavoriteEmailUpdate.vue?vue&type=script&lang=js&"
export * from "./FavoriteEmailUpdate.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteEmailUpdate.vue?vue&type=style&index=0&id=4db2400b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db2400b",
  null
  
)

export default component.exports